import { useResponsive } from '@/features/responsive/hooks/useResponsive.ts'
import { useModalControlStore } from '@/domains/header/model/store.ts'
import { cn } from '@lair-finance/util'
import { CurrentChain } from '@/domains/header/ui/Wallet/CurrentChain.tsx'
import { Popover, PopoverClose, PopoverContent, PopoverOverlay, PopoverPortal, PopoverTrigger } from '@/shared/ui/Popover'
import { ConnectedButton } from '@/domains/header/ui/Wallet/ConnectedButton.tsx'
import { WalletModal } from '@/domains/header/ui/WalletModal'
import { ConnectButton } from '@/domains/header/ui/Wallet/ConnectButton.tsx'
import { Dialog, DialogPortal, DialogTrigger } from '@/shared/ui/Dialog'
import { ToggleButton } from '@/domains/header/ui/ToggleButton.tsx'
import { HeaderContent } from '@/domains/header/ui/HeaderContent.tsx'
import { MenuModal } from '@/domains/header/ui/MenuModal'
import { Footer } from '@/shared/ui/Footer'
import { useWallet } from '@lair-finance/wallet'
import { NotificationBar } from '@/domains/header/ui/NotificationBar.tsx'

export function HeaderActions({ className }: { className?: string }) {
  const isDesktop = useResponsive('desktop')
  const { isConnected } = useWallet()
  const [activeModal, openModal, closeModal] = useModalControlStore(state => [state.activeModal, state.openModal, state.closeModal])

  return (
    <div className={cn('inline-flex items-center gap-x-3 sm:gap-x-2', className)}>
      <CurrentChain className={'max-sm:hidden'} />

      {isConnected ? (
        <Popover open={activeModal === 'wallet'} onOpenChange={open => openModal(open ? 'wallet' : null)}>
          <PopoverTrigger>
            <ConnectedButton className={cn({ 'border-greyscale-50': activeModal === 'wallet' })} />
          </PopoverTrigger>
          {!isDesktop && (
            <PopoverPortal>
              <PopoverClose asChild>
                <PopoverOverlay />
              </PopoverClose>
            </PopoverPortal>
          )}
          <PopoverContent sideOffset={isDesktop ? 8 : 15} side={'bottom'} align={'end'} preventCloseOnOutsideClick noStyle>
            <WalletModal />
          </PopoverContent>
        </Popover>
      ) : (
        <ConnectButton />
      )}

      <Dialog
        open={activeModal === 'menu'}
        onOpenChange={open => {
          if (!open) {
            openModal(null)
            return
          }

          openModal(activeModal === 'wallet' ? null : 'menu')
        }}
      >
        <DialogTrigger>
          <ToggleButton className={'md:hidden'} active={activeModal !== null} />
        </DialogTrigger>
        <DialogPortal>
          <div className={'fixed inset-0 w-screen h-screen flex flex-col z-50 overflow-hidden'} style={{ scrollbarGutter: 'stable' }}>
            <NotificationBar className={'flex-shrink-0'} />
            <HeaderContent className={'flex-shrink-0'} actions={<ToggleButton active={activeModal !== null} onClick={() => closeModal()} />} />
            <MenuModal />
            <Footer className={'flex-shrink-0'} />
          </div>
        </DialogPortal>
      </Dialog>
    </div>
  )
}
